import { render, staticRenderFns } from "./menuSwitch.vue?vue&type=template&id=a3f498ca&scoped=true&"
import script from "./menuSwitch.vue?vue&type=script&lang=js&"
export * from "./menuSwitch.vue?vue&type=script&lang=js&"
import style0 from "./menuSwitch.vue?vue&type=style&index=0&id=a3f498ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f498ca",
  null
  
)

export default component.exports